/** The partner module's reads and writes of the API: TanStack Query hooks, and a few plain calls for a form to make as it is filled in. */
import { useQuery } from '@tanstack/react-query'
import { apiGet } from '../core/index.js'
import type { RankingDecision, ShiftOutcome } from './types.js'

/** A worker's reported shift outcomes, most recent shift first. */
export function useWorkerOutcomes(workerId: string | null) {
  return useQuery({
    queryKey: ['worker-outcomes', workerId],
    queryFn: () => apiGet<ShiftOutcome[]>(`/workers/${workerId as string}/outcomes`),
    enabled: workerId !== null,
  })
}

/** The facility's most recent partner rankings, newest first. */
export function useFacilityRankings(facilityId: string) {
  return useQuery({
    queryKey: ['facility-rankings', facilityId],
    queryFn: () => apiGet<RankingDecision[]>(`/facilities/${facilityId}/rankings`),
  })
}
